<template>
  <nav class="nav-principal">
    <div class="container" id="nav" style="padding-top: 2rem">
      <div class="logo-float d-none d-xl-block">
        <a :href="'/'">
          <img src="./assets/svg/logo.svg" alt="logo" class="logo" /> 
        </a>
      </div>
      <div class="d-flex ">
        <ul class="menu-lg">
          <li
            class="d-none d-xl-block"
            v-for="item in mainMenu"
            :key="item.label"
          >
            <a :href="item.anchor">{{ item.label }}</a>
          </li>
          <li :class="`${showMenuOverlay ? '' : 'd-block d-xl-none'}`">
            <transition name="no-mode-fade">
              <div class="bg-dark p-2 px-3">
                <i
                  class="h2 pointer"
                  :class="{
                    'ri-menu-line': !showMenuOverlay,
                    'ri-close-line': showMenuOverlay
                  }"
                  @click="menuOverlay().update()"
                ></i>
              </div>
            </transition>
          </li>
        </ul>
      </div>
      <div>
        <router-link :to="{ name: 'pa-Crear cuenta' }" class="btn btn-link btn-sm mr-2 text-light">Crear una cuenta</router-link>
        <a href="https://login.alliance-cloud.com/passport/login" class="btn btn-primary btn-sm">
          <i class="ri-login-box-fill small mr-1"></i> Iniciar sesión
        </a> 
      </div>
    </div> 
  </nav>
  <div class="botonWhatsApp" @click="enviarMensaje()"> 
     <i class="ri-whatsapp-line mr-2"></i>  Si estas interesado, haz click aqui y contactanos via WhatsApp 
     </div>  
  <nav class="overlay" ref="menuOverlay">
    <ul>
      <li
        v-for="item in mainMenu"
        :key="item.label"
        @click="() => {showMenuOverlay = !showMenuOverlay}">
        <a :href="item.anchor" class="h2">{{ item.label }}</a>
      </li> 
      <li class="mt-3">
        <a
          class="text-muted mt-2"
          :href="`mailto:${email}?subject= Alliance`"
          target="_blank"
          rel="noopener"
        >
          Say Hola! <span class="emojii-wrap">👋</span>
        </a>
      </li>
    </ul>
  </nav>  

  <router-view/> 
  <FooterPa></FooterPa> 
</template>

<script>  
import { mainMenuPa }  from "./utils/Menu";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Footer from "./views/home/sections/Footer.vue";

gsap.registerPlugin(ScrollTrigger);

import { useRouter } from 'vue-router';
const router = useRouter();
 
  

import {email, phone_pa} from "./utils/helpers" 
import FooterPa from "./views/home/sections_pa/FooterPa.vue";

export default {
  name: "LayoutPa",
  components: {
    FooterPa
  },
  data() {
    return {
      email: email,
      showMenuOverlay: false,
      mainMenu: [...mainMenuPa]
    };
  },
  watch: {
  showMenuOverlay(newValue) {
      if (newValue) {
        this.menuOverlay().open();
      } else {
        this.menuOverlay().close();
      }
    }
  },
  mounted() {
      const preLoading = document.getElementById("preLoading");
     preLoading.classList += " leave";
  },
  methods: {
      enviarMensaje() {
        const phoneNumber = phone_pa.number; // Reemplaza con el número de WhatsApp (sin signos ni espacios)
        const messageFijo = encodeURIComponent(`¡Hola! Me gustaría obtener más información sobre Alliance.`); // Tu mensaje personalizado 
        const url = `https://wa.me/${phoneNumber}?text=${messageFijo}`;
        window.open(url, "_blank");
      },
    menuOverlay() {
      return {
        update: () => {
          console.log('entrk');
          this.$data.showMenuOverlay = !this.$data.showMenuOverlay;
        },
        open: () => {
          const nav = this.$refs.menuOverlay;
          const ul = nav.querySelector("ul");
          nav.style.zIndex = 80;
          const tl = gsap.timeline();
          tl.to(this.$refs.menuOverlay, {
            duration: 0.1,
            width: window.innerWidth
          });
          tl.fromTo(
            ul.children,
            {
              opacity: 0,
              x: -100
            },
            {
              delay: 0.15,
              duration: 0.5,
              opacity: 1,
              x: 0,
              stagger: 0.2
            }
          );
        },
        close: () => {
          const nav = this.$refs.menuOverlay;
          const ul = nav.querySelector("ul");
          const tl = gsap.timeline();
          tl.to(
            ul.children,
            {
              duration: 0.5,
              opacity: 0,
              x: -100,
              stagger: 0.2
            },
            "root"
          );
          tl.to(
            this.$refs.menuOverlay,
            {
              duration: 0.5,
              width: 0,
              onComplete: () => {
                nav.style.zIndex = -2;
              }
            },
            "-=0.8"
          );
        },
        goToDemo: () => {
          this.$router.push({ name: "pa-Crear cuenta" });
        },
        goToHome: () => { 
          console.log('ejtr');
         this.$router.push('/');
        }
      };
    },
  
  }
};

</script>

<style lang="scss">
@use "scss";

.nav-principal {  
  height: 90px;
    background: #0c1c2a;

}

.logo {
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}

 .botonWhatsApp {
    width: 100%; 
    color: #fff;
    display: flex;
    align-items: center; 
    justify-content: center;
    background: #2a9b4c;
    background: linear-gradient(90deg, rgba(42, 155, 76, 1) 0%, rgba(87, 199, 133, 1) 50%, rgba(237, 221, 83, 1) 100%);
    padding: 10px;
    font-size: 20px;
    cursor: pointer;
  }

  .font-30 {
    font-size: 30px;
    a {
      cursor: pointer;
      text-decoration: none;
      color: #fff;
    }
  }

</style>
